var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7022 11.1541L6.09327 2.50791L17.0465 8.80602L14.7022 11.1541ZM3.84646 2C3.33936 2.26568 3 2.75015 3 3.37918V20.6208C3 21.2499 3.33936 21.7343 3.84646 22L13.8557 11.998L3.84646 2ZM20.4323 10.8142L18.1348 9.48193L15.572 12.002L18.1348 14.522L20.4791 13.1897C21.1812 12.631 21.1812 11.3729 20.4323 10.8142ZM6.09327 21.496L17.0465 15.1979L14.7022 12.8498L6.09327 21.496Z",
    fill: "#020617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGooglePlay);
export default __webpack_public_path__ + "static/media/icon-google-play.f496b308d5d1bcf900b93f445d7cbc91.svg";
export { ForwardRef as ReactComponent };